import { render, staticRenderFns } from "./courses_detail.vue?vue&type=template&id=7bc23720&"
import script from "./courses_detail.vue?vue&type=script&lang=js&"
export * from "./courses_detail.vue?vue&type=script&lang=js&"
import style0 from "./courses_detail.vue?vue&type=style&index=0&id=7bc23720&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports